import { useState } from 'react'
import { motion } from 'framer-motion'
import LanguageToggle from './components/LanguageToggle'
import HeroSection from './components/HeroSection'
import ProblemSection from './components/ProblemSection'
import HowItWorks from './components/HowItWorks'
import WhoItsFor from './components/WhoItsFor'
import PricingSection from './components/PricingSection'
import FAQSection from './components/FAQSection'
import EmailCapture from './components/EmailCapture'
import { translations } from './translations'

function App() {
  const [language, setLanguage] = useState('ja')
  const t = translations[language]

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'ja' ? 'en' : 'ja')
  }

  return (
    <div className="min-h-screen">
      {/* Fixed Language Toggle */}
      <LanguageToggle 
        language={language} 
        onToggle={toggleLanguage} 
      />

      {/* Hero Section with Pattern Background */}
      <div className="bg-pattern-dots">
        <HeroSection t={t} language={language} />
      </div>

      {/* Problem Section */}
      <ProblemSection t={t} />

      {/* How It Works */}
      <div className="bg-white">
        <HowItWorks t={t} />
      </div>

      {/* Who It's For */}
      <WhoItsFor t={t} />

      {/* Pricing */}
      <div className="bg-gradient-to-br from-primary-50 to-warm-cream">
        <PricingSection t={t} />
      </div>

      {/* FAQ */}
      <div className="bg-white">
        <FAQSection t={t} />
      </div>

      {/* Email Capture - Final CTA */}
      <div className="bg-pattern-grid bg-warm-sand">
        <EmailCapture t={t} language={language} />
      </div>

      {/* Footer */}
      <footer className="bg-neutral-900 text-neutral-300 py-12 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <motion.p 
              className="text-2xl font-display font-medium text-white mb-2"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
            >
              {t.footer.tagline}
            </motion.p>
            <p className="text-sm text-neutral-400">
              元気です (Genki Desu) © 2026 - Made with care for people living alone
            </p>
          </div>
          
          <div className="flex flex-wrap justify-center gap-6 text-sm">
            <a href="#" className="hover:text-primary-400 transition-colors">
              {t.footer.privacy}
            </a>
            <a href="#" className="hover:text-primary-400 transition-colors">
              {t.footer.terms}
            </a>
            <a href="mailto:hello@genkidesu.app" className="hover:text-primary-400 transition-colors">
              {t.footer.contact}
            </a>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default App
